import React from 'react';
import {
  View, StyleSheet, Text, FlatList, ViewStyle, ActivityIndicator,
} from 'react-native';
import Colors from '../../../../constants/Colors';

export type BookingsListDataItem = {
  startTime: string,
  endTime: string,
  count: number,
}

interface BookingsListProps {
  data?: BookingsListDataItem[],
  itemStyle?: ViewStyle | ViewStyle[],
}

const BookingsList = ({ data, itemStyle }: BookingsListProps) => <FlatList
  {...{ data }}
  renderItem={({ item: { startTime, endTime, count } }
    : { item: BookingsListDataItem }) => <View style={[styles.item, itemStyle]}>
      <Text style={styles.text}>{`${startTime} - ${endTime}`}</Text>
      <Text style={styles.text}>{`${count ?? '-'} people`}</Text>
    </View>}
  ListHeaderComponent={<View style={styles.listHeader}>
    <Text style={styles.listHeaderText}>{'TIME'}</Text>
    <Text style={styles.listHeaderText}>{'PEOPLE BOOKED'}</Text>
  </View>}
  keyExtractor={(_, index: number) => `bookings_list_${index}`}
  ListEmptyComponent={data ? <Text style={styles.emptyText}>
    {`No ${data ? 'bookings' : 'data'} available`}
  </Text> : <ActivityIndicator
    style={styles.loadingIndicator}
    size='large'
  />}
  style={styles.container}
/>;

const styles = StyleSheet.create({
  container: {
    minHeight: 240,
  },
  item: {
    paddingHorizontal: 16,
    paddingVertical: 10,
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: Colors.light.hereworksBlue100,
    backgroundColor: Colors.light.hereworksWhite200,
    marginTop: 8,
    borderRadius: 12,
    height: 60,
  },
  text: {
    flex: 1,
    fontSize: 14,
    lineHeight: 21,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlack600,
  },
  listHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8,
    paddingBottom: 8,
    borderBottomWidth: 1,
    borderBottomColor: Colors.light.hereworksWhite500,
    paddingHorizontal: 16,
  },
  listHeaderText: {
    fontSize: 10,
    lineHeight: 16,
    fontFamily: 'Roboto_500Medium',
    color: Colors.light.hereworksBlack400,
    flex: 1,
  },
  emptyText: {
    fontSize: 14,
    lineHeight: 21,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlack600,
    alignSelf: 'center',
    textAlign: 'center',
    marginTop: '15%',
    marginBottom: '25%',
  },
  loadingIndicator: {
    marginTop: '15%',
  },
});

export default BookingsList;
